import { Badge, Divider, Fab, Grid, TextField, Typography, useMediaQuery } from '@mui/material';
import React, { useState } from 'react' 
import style from "../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import popupStyles from "../../../../../assets/styles/componentStyles/globalPopupStyles.module.scss"
import chatStyles from "../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import chatLogsPreviewStyles from "../../../../../assets/styles/componentStyles/chatLogsStyles/chatLogsTemplatePreview.module.scss";
import globalStyles from "../../../../../assets/styles/global.module.scss";
import { uploadedMedia } from '../../../../../models/axiosModel';
import SendIcon from '@mui/icons-material/Send';
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import IconsColor from '../../../../../components/utility/iconsColor';
import ShortTextIcon from '@mui/icons-material/ShortText';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { blackColor } from '../../../../../utils/colors';

interface FileUploadPopupProps {
    selectedMediaSet: uploadedMedia[],
    setSelectedMediaSet: React.Dispatch<React.SetStateAction<uploadedMedia[]>>,
    hiddenFileInput?: React.MutableRefObject<HTMLInputElement | null>,
    removeFileHandler?: (index: number) => void,
    uploadMedia: () => Promise<void>,
}  

const FileUploadPopup: React.FC<FileUploadPopupProps> = (props) => {

    const { selectedMediaSet, setSelectedMediaSet, hiddenFileInput, removeFileHandler, uploadMedia } = props;

    const smallScreen = useMediaQuery<boolean>('(max-width : 1220px) and (min-width : 0px)');
    const [currentSelectedMediaCount, setCurrentSelectedMediaCount] = useState<number>(0);

    const renderMediaComponent = (type: string, url: string, flagPreviewMedia: boolean) => {
        switch(type.toLowerCase()){
            case 'image': 
                return <img src={url} alt='img' className={`${flagPreviewMedia ? chatStyles.mediaPreviewImg : chatStyles.mediaImg}`} />;
            case 'video': 
                return <>
                    {flagPreviewMedia ?
                        <Grid container className={`${globalStyles.displayFlexStyle} ${globalStyles.justifyCenter} ${globalStyles.alignItemCenter} ${globalStyles.fullHeight}`}>
                            <Grid item className={`${globalStyles.displayFlexStyle}`}>
                                <IconsColor iconName="videoFile" fillColor={blackColor} />
                            </Grid>
                        </Grid>
                        :
                        <video controls className={`${flagPreviewMedia ? chatStyles.mediaPreviewImg : chatStyles.mediaImg}`}> 
                            <source src={url} />
                        </video>
                    }
                </> 
            case 'document': 
                return <Grid container className={`${flagPreviewMedia ? chatStyles.documentMediaContainer : chatStyles.documentMedia} ${globalStyles.displayFlexStyle} ${globalStyles.justifyCenter} ${globalStyles.alignItemCenter} ${globalStyles.flexColumn} ${globalStyles.relativePosition}`}>
                    <Grid item className={`${globalStyles.displayFlexStyle}`}>
                        <ArticleOutlinedIcon />
                    </Grid>
                    {!flagPreviewMedia && 
                        <>
                            <Grid item>
                                <Typography className={chatStyles.mediaFileNameTypography} >No Preview Available</Typography>
                            </Grid>
                            <Grid item>
                                <OpenInNewIcon className={chatLogsPreviewStyles.openDocumentIcon} onClick={() => window.open(url, "_blank")} />
                            </Grid> 
                        </>
                    }
                </Grid>
            case 'text': 
                return <>
                    {flagPreviewMedia && 
                        <Grid container className={`${globalStyles.displayFlexStyle} ${globalStyles.justifyCenter} ${globalStyles.alignItemCenter} ${globalStyles.fullHeight}`}>
                            <Grid item className={`${globalStyles.displayFlexStyle}`}>
                                <ShortTextIcon />
                            </Grid>
                        </Grid>
                    }
                </>
            default: 
                return <></>;
        }
    }

    const handleDeleteMedia = async (index: number) => {
        if(removeFileHandler){
            await removeFileHandler(index);
        }
        setCurrentSelectedMediaCount(0);
    }

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container direction={"column"} justifyContent={"center"}>
                        <Grid item textAlign={"center"}>
                            <Typography className={popupStyles.popupTitleTypography}>Preview</Typography>
                        </Grid>

                        <Divider className={popupStyles.popupTitleDivider} />

                        <Grid item>
                            <Grid container className={popupStyles.popupBodyGridContainer} gap={1}>
                                <Grid item xs={12} className={`${globalStyles.displayFlexStyle} ${globalStyles.justifyCenter}`}>
                                    {renderMediaComponent(selectedMediaSet?.[currentSelectedMediaCount]?.type, selectedMediaSet?.[currentSelectedMediaCount]?.url, false)}
                                </Grid>
                                <Grid item xs={12} className={`${globalStyles.displayFlexStyle} ${globalStyles.justifyCenter}`}>
                                    <Typography className={chatStyles.mediaFileNameTypography}>
                                        {selectedMediaSet?.[currentSelectedMediaCount]?.file_name}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item>
                            <Grid container className={popupStyles.popupBodyGridContainer} gap={1}>
                                <Grid item xs={12}>
                                    <TextField
                                        value={selectedMediaSet?.[currentSelectedMediaCount]?.caption ?? ''}
                                        onChange={(e) => { 
                                            setSelectedMediaSet((prev) => {
                                                return prev.map((media, index) => {
                                                    if(index === currentSelectedMediaCount){
                                                        return {
                                                            ...media, 
                                                            caption: e.target.value,
                                                        }
                                                    }
                                                    return media;
                                                })
                                            })
                                        }}
                                        placeholder='Add Caption'
                                        className={`${style.campaignContactPopupTextField} ${globalStyles.fullwidth}`}
                                    />  
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item className={chatStyles.previewSectionGrid}>
                            <Grid container className={`${chatStyles.previewSectionMainContainer} ${globalStyles.alignItemCenter}`} gap={"15px"} flexWrap={"nowrap"}>
                                <Grid item xs={smallScreen ? 10 : 11} className={globalStyles.overflowAuto}> 
                                    <Grid container className={`${globalStyles.displayFlexStyle} ${globalStyles.justifyCenter} ${globalStyles.overflowAuto} ${chatStyles.previewSectionContainer}`}>
                                        {selectedMediaSet?.map((media, index) => {
                                            return (
                                                <Grid item className={`${chatStyles.mediaPreviewGrid} ${globalStyles.clickable}`} sx={{border: index === currentSelectedMediaCount ? '2px solid green' : 'none'}} onClick={() => setCurrentSelectedMediaCount(index)}>
                                                    {renderMediaComponent(media?.type, media?.url, true)}
                                                    <ClearIcon className={chatStyles.clearMediaIcon} onClick={(e) => {e.stopPropagation(); handleDeleteMedia(index)}} />
                                                </Grid>
                                            );
                                        })}
                                        <Grid item className={`${chatStyles.mediaPreviewGrid} ${globalStyles.clickable} ${globalStyles.displayFlexStyle} ${globalStyles.alignItemCenter} ${globalStyles.justifyCenter}`} onClick={() => hiddenFileInput?.current?.click()}>
                                            <AddIcon />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={0.5} className={globalStyles.clickable} onClick={() => uploadMedia()}> 
                                    <Badge
                                        badgeContent={selectedMediaSet.length}
                                        color="error"
                                        overlap="circular" 
                                        className={chatStyles.sendButtonBadge}
                                    >
                                        <Fab className={chatStyles.sendIconFab} size="medium" aria-label="send">
                                            <SendIcon className={chatStyles.sendMediaIcon} />
                                        </Fab>
                                    </Badge>
                                </Grid>
                            </Grid>  
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default FileUploadPopup
